export default __webpack_public_path__ + "static/bg-1ed83c2f7db44b00fc5b913d38188255.png";